import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { useQuery } from '@tanstack/react-query'
import { UsersService } from '@mc/persona-api'
import { sprigTrackEvent } from '../../sprig'

export const useSilentCoachFeedbackSurvey = () => {
  const router = useRouter()
  const previousPathRef = useRef<string>('')
  const storedConversationIdRef = useRef<string | null>(null)

  const { data: userMCMe } = useQuery({
    queryFn: () => UsersService.getUser({ uuid: 'me' }),
    queryKey: ['me'],
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

  useEffect(() => {
    const currentPath = router.asPath
    const previousPath = previousPathRef.current

    const isOnFeedbackPage = currentPath.includes('/meetings/feedback')
    const wasOnFeedbackPage = previousPath.includes('/meetings/feedback')

    if (isOnFeedbackPage && !wasOnFeedbackPage) {
      // Extract conversation ID from the URL path
      const urlParams = new URLSearchParams(currentPath.split('?')[1] || '')
      const conversationId = urlParams.get('uuid')
      if (conversationId) {
        storedConversationIdRef.current = conversationId
      }
    }

    if (
      wasOnFeedbackPage &&
      !isOnFeedbackPage &&
      userMCMe &&
      storedConversationIdRef.current
    ) {
      sprigTrackEvent('Silent Coach Feedback Closed', {
        userId: userMCMe.analytics?.userId,
        conversationId: storedConversationIdRef.current,
      })

      storedConversationIdRef.current = null
    }

    previousPathRef.current = currentPath
  }, [router.asPath, userMCMe])
}
